import { render, staticRenderFns } from "./selectCustomer.vue?vue&type=template&id=a5ca6ed6&scoped=true&"
import script from "./selectCustomer.vue?vue&type=script&lang=js&"
export * from "./selectCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ca6ed6",
  null
  
)

export default component.exports